import * as React from "react";
const SvgSubdirectoryArrowRightOutlined = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <path fill="none" d="M24 24H0V0h24v24z" opacity={0.87} />
    <path d="m19 15-6 6-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9l6 6z" />
  </svg>
);
export default SvgSubdirectoryArrowRightOutlined;
